import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api, { formatApiError } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get('/auth/me');
        if (!cancelled) setUser(data);
      } catch (e) {
        try {
          const { data } = await api.post('/auth/refresh');
          if (!cancelled) setUser(data);
        } catch (e2) {
          if (!cancelled) setUser(false);
        }
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await api.post('/auth/login', { email, password });
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  }, []);

  const register = useCallback(async (name, email, password, phone) => {
    try {
      const { data } = await api.post('/auth/register', { name, email, password, phone });
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  }, []);

  const registerMerchant = useCallback(async (name, email, password, phone) => {
    try {
      const { data } = await api.post('/auth/register-merchant', { name, email, password, phone });
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  }, []);

  const becomeMerchant = useCallback(async () => {
    try {
      const { data } = await api.post('/auth/become-merchant');
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  }, []);

  const logout = useCallback(async () => {
    try { await api.post('/auth/logout'); } catch (e) { /* ignore */ }
    setUser(false);
  }, []);

  const updateUser = (patch) => setUser((u) => (u ? { ...u, ...patch } : u));

  return (
    <AuthContext.Provider value={{ user, login, register, registerMerchant, becomeMerchant, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function homeForRole(role) {
  if (role === 'merchant') return '/merchant-center';
  if (role === 'admin') return '/admin';
  if (role === 'rider') return '/delivery';
  return '/my-kelate';
}
